<template>
    <div id="app" :class="{ chrome: isChrome, desktop: isDesktop }">
        <app-header></app-header>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import is from 'is_js'

export default {
    name: 'app',
    components: {
        'app-header': Header,
        'app-footer': Footer
    },
    computed: {
        isChrome () {
            return is.chrome()
        },
        isDesktop () {
            return is.desktop()
        }
    }
}
</script>



// WEBPACK FOOTER //
// App.vue?9cedb83a